import React from 'react';
import { components, OptionProps, SelectComponentsConfig } from 'react-select';

export const WIDE_MENU_CLASS = 'wide-select-menu';
export const WIDE_OPTION_CLASS = 'wide-select-option';

// An option whose full text is on hover, for when the menu cuts a long one short with an ellipsis.
const TitledOption = (props: OptionProps<any, boolean>) => (
  <components.Option {...props} innerProps={{ ...props.innerProps, title: props.label }} />
);

/**
 * Opt-in props (spread onto a react-select) for a menu that is wider than its control: portalled to
 * the body so no toolbar or table clips it, sized to its content up to a cap, one line per option
 * with the full text in a title. The sizing is in components/_select.scss (.wide-select-menu). Off by default:
 * a select only gets this when its `wideMenu` prop is set.
 */
export const wideMenuProps = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : undefined,
  classNames: {
    menu: () => WIDE_MENU_CLASS,
    option: () => WIDE_OPTION_CLASS,
  },
  components: { Option: TitledOption } as SelectComponentsConfig<any, boolean, any>,
};
